import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const DELETE_ZONE = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Está seguro de eliminar la zona?',
    valueButton: 'Eliminar',
    color: CONFIRM_COLOR.WARN,
    icon: CONFIRM_ICONS.IMPORTANT
  };
